import { inject } from '@angular/core';
import { GuardResult, MaybeAsync, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { Permission, PermissionName, User } from '@core/api/model';
import { AuthService } from '@core/auth-service/auth.service';

export function hasUserCondition(
  checkAccess: (user: User) => boolean,
): () => MaybeAsync<GuardResult> {
  return () => {
    const router = inject(Router);
    return inject(AuthService).loggedInUser$.pipe(
      take(1),
      map((user) => {
        if (!user) {
          return false;
        }
        if (checkAccess(user)) {
          return true;
        }

        if (router.currentNavigation()?.extras.state?.fromDefaultPageGuard) {
          console.warn('User has no permission for start page ' + user.startPage);
          return router.createUrlTree(['/']); // no use in going back to default route
        }

        return router.createUrlTree(['/default']);
      }),
    );
  };
}

export function hasPermission(
  permission: PermissionName | PermissionName[],
): () => MaybeAsync<GuardResult> {
  const permissions = typeof permission === 'string' ? [permission] : permission;
  return hasUserCondition((user: User) =>
    permissions.some((permission) => user.hasPermission(Permission[permission])),
  );
}
